<div>
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <button id="print-button" class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none; "
            mat-raised-button color="primary" printSectionId="print-section" [useExistingCss]="true" ngxPrint>
            Print
        </button>

        <button (click)="print()" class="noPrint"
            style="margin-top: 2%; margin-left: 2%; background-color: #3f51b5;color: white;" mat-raised-button
            color="primary">
            Print
        </button>
        <button class="noPrint" style="margin-top: 2%; margin-left: 2%; background-color: #3f51b5;color: white;"
            (click)="exportExcel('issue_seller_Invoice_Register')" mat-raised-button color="primary">
            Export
        </button>
        <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
   <div id="print-section" style="margin-top: 50px; margin-left: 20px;">
  <table class="table table-bordered" style="border-collapse: collapse; width: 100%;">
    <thead>
      <tr style="background-color: #f0f0f0;">
        <th colspan="3" style="border: 1px solid #000;" class="br-bottom br-right br-top">हिंदुस्तान प्रकाशन संस्था - विवेक साप्ताहिक</th>
        <th colspan="3" style="border: 1px solid #000;" class="br-bottom br-right br-top">अंकाचे नाव : {{newissuedatepp}}</th>
        <th colspan="3" style="border: 1px solid #000;" class="br-bottom br-right br-top">Datewise Register Report - In Details</th>
        <th colspan="2" style="border: 1px solid #000;" class="br-bottom br-right br-top">अंकाचे कॅटेगरी : {{issue_cat}}</th>
        <th colspan="2" style="border: 1px solid #000;" class="br-bottom br-right br-top">Date : From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date: 'dd-MM-yyyy' }}</th>
        <th colspan="2" style="border: 1px solid #000;" class="br-bottom br-right br-top">दिनांक : {{today1}}</th>
        <th colspan="2" style="border: 1px solid #000;" class="br-bottom br-top">पृष्ठ क्र : 1</th>
      </tr>

      <tr style="background-color: #d9d9d9;">
        <th style="border: 1px solid #000;">Sr</th>
        <th style="border: 1px solid #000;">Booking Date</th>
        <th style="border: 1px solid #000;">Booking No</th>
        <th style="border: 1px solid #000;">Issue Seller Name</th>
        <th style="border: 1px solid #000;">Representative Name</th>
        <th style="border: 1px solid #000;">Mobile Number</th>
        <th style="border: 1px solid #000;">Office Rep Name</th>
        <th style="border: 1px solid #000;">Receipt Number & Date</th>
        <th style="border: 1px solid #000;">Issue Copies</th>
        <th style="border: 1px solid #000;">Issue Amt</th>
        <th style="border: 1px solid #000;">Disc Amt</th>
        <th style="border: 1px solid #000;">Net Amt</th>
        <!-- <th style="border: 1px solid #000;">Before GST Amt</th> -->
        <th style="border: 1px solid #000;">GST</th>
        <th style="border: 1px solid #000;">Total Amt</th>
        <th style="border: 1px solid #000;">जमा बाकी</th>
        <th style="border: 1px solid #000;">येणे बाकी</th>
      </tr>
    </thead>

    <tbody>
      <ng-container *ngFor="let item1 of inDetailsRegReportdatewise; let i = index">
        <tr style="background-color: #e5ecf9;">
          <td colspan="2" style="border: 1px solid #000;">Booking Date: {{item1.booking_date}}</td>
          <td colspan="15" style="border: 1px solid #000;"></td>
        </tr>

        <ng-container *ngFor="let item of item1.issue_data">
          <tr>
            <td style="border: 1px solid #000;">{{item.issue_id}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{item.booking_date}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{item.booking_no}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{item.issue_seller_name}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{item.rep_name}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{item.rep_mob_no}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{item.off_rep_name}}</td>
            <td style="border: 1px solid #000;">{{item.rep_rcpt_no}} {{item.rcpt_date}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{item.issue_copies}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{item.issue_amt}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{item.disc_amt}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{item.net_amount}}</td>
            <!-- <td style="border: 1px solid #000; text-align: end;">{{item.beforegst_amt}}</td> -->
            <td style="border: 1px solid #000; text-align: end;">{{item.totalgst}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{item.total_amount + item.totalgst}}</td>
            <td style="border: 1px solid #000; text-align: end;">{{ item.pymt_rcv_amt ? +item.pymt_rcv_amt : 0 }}</td>
            <td style="border: 1px solid #000; text-align: end;">{{ (item.net_amount) - item.pymt_rcv_amt | number: '1.2-2' }}</td>
          </tr>
        </ng-container>

        <!-- Section Total Row -->
        <tr style="background-color:white; font-weight: bold;">
          <td colspan="8" style="border: 1px solid #000; text-align: right;">Total</td>
          <td style="border: 1px solid #000; text-align: end;">{{item1.issue_copies}}</td>
          <td style="border: 1px solid #000; text-align: end;">{{item1.total_advt_amount}}</td>
          <td style="border: 1px solid #000; text-align: end;">{{item1.total_discount}}</td>
          <!-- <td style="border: 1px solid #000; text-align: end;">{{item1.total_before_gst}}</td> -->
          
           <td style="border: 1px solid #000; text-align: end;">{{item1.total_amt}}</td> 
          <td style="border: 1px solid #000; text-align: end;">{{item1.total_gst}}</td>
          <td style="border: 1px solid #000; text-align: end;">{{item1.total_amt}}</td>
          <td style="border: 1px solid #000; text-align: end;">{{item1.total_rcv}}</td>
          <td style="border: 1px solid #000; text-align: end;"> {{ (item1.total_amt || 0) - (item1.total_rcv || 0) }}</td>
        </tr>
      </ng-container>
    </tbody>

    <tfoot>
      <tr style="background-color:lavender; font-weight: bold;">
        <td style="border: 1px solid #000;">{{inDetailsRegReportdatewise.length}}</td>
        <td colspan="7" style="border: 1px solid #000; text-align: center;">एकूण</td>
        <td style="border: 1px solid #000; text-align: end;">{{issueCopies}}</td>
        <td style="border: 1px solid #000; text-align: end;">{{issue_amt}}</td>
        <td style="border: 1px solid #000; text-align: end;">{{totaldisc_total}}</td>
        <td style="border: 1px solid #000; text-align: end;">{{netissueamt}}</td>
        <!-- <td style="border: 1px solid #000; text-align: end;">{{totaladvtamt}}</td> -->
        <td style="border: 1px solid #000; text-align: end;">{{totalgst}}</td>
        <td style="border: 1px solid #000; text-align: end;">{{totaladvtamt}}</td>
       
        <td style="border: 1px solid #000; text-align: end;">{{jamatotal}}</td>
        <td style="border: 1px solid #000; text-align: end;">{{totaladvtamt - jamatotal}}</td>
      </tr>
    </tfoot>
  </table>
</div>
